'use client';
import React from 'react';

const macros = [
  { label: 'Calories', consumed: 1740, target: 1950, unit: 'kcal' },
  { label: 'Protein', consumed: 168, target: 185, unit: 'g' },
  { label: 'Carbs', consumed: 142, target: 160, unit: 'g' },
  { label: 'Fat', consumed: 62, target: 65, unit: 'g' },
  { label: 'Fibre', consumed: 22, target: 30, unit: 'g' },
];

export default function MacroSummaryBar() {
  return (
    <div className="card-forge rounded-xl p-4">
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-4">
        {macros?.map((m) => {
          const pct = Math.min((m?.consumed / m?.target) * 100, 100);
          const remaining = m?.target - m?.consumed;
          const isOver = m?.consumed > m?.target;
          const color = isOver ? 'var(--destructive)' : pct >= 90 ? 'var(--primary)' : 'var(--accent)';
          return (
            <div key={`summary-${m?.label}`} className="text-center">
              <div className="text-forge-label mb-1">{m?.label}</div>
              <div className="font-tabular font-black text-lg text-foreground leading-none">
                {m?.consumed}
                <span className="text-xs text-muted-foreground font-medium"> {m?.unit}</span>
              </div>
              <div className="text-2xs text-muted-foreground mb-1.5">
                {isOver ? (
                  <span className="text-destructive font-bold">+{Math.abs(remaining)} over</span>
                ) : (
                  `${remaining} remaining`
                )}
              </div>
              <div className="macro-bar-track">
                <div className="h-full rounded-full transition-all" style={{ width: `${pct}%`, backgroundColor: color }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}